/*
 * author: wxq
 * createdTime: 2019/04/11
 */

/* 修改记录：
 * 1、添加urlParams请求方式（石志鹏：2019-08-15）
 * 2、修改下拉如果是对象不是数组类型时转化，添加props:isObject（石志鹏：2019-08-15）
 * 3、选中下拉回调返回的children截取掉key（石志鹏：2019-08-15）
 */

/**
 * label                       string                 false               label文字
 * dateApi                     api
 * date                        [{key：'', value: ''}]
 * type                        string[search,arrow]   arrow               下拉需不需要下拉的箭头
 * selectItem                  [{key：'', value: ''}]
 * searchParams
 */
import React, { PureComponent } from 'react';
import { Select, Spin } from 'antd';
import { getData } from '@util';
const Option = Select.Option;
class CsxFormSelect extends PureComponent {
  constructor() {
    super();
    this.state = {
      menu: '', // 下拉菜单
      fetching: false,
    };
  }
  componentDidMount() {}
  getAsyncDate(dateApi) {
    const reqData = { api: dateApi };
    const { searchParams, urlParams } = this.props;
    if (searchParams) {
      reqData.searchParams = searchParams;
    }
    //szp：2019-08-15
    if (urlParams) {
      reqData.urlParams = urlParams;
    }
    this.setState({ fetching: true });
    getData(reqData).then(data => {
      if (data.result || data.data) {
        const menuObj = this.getMenu(data.result || data.data);
        this.setState({ ...menuObj, fetching: false });
      }
    });
  }

  // 组合menu菜单
  getMenu(dataObj) {
    const { selectItem, isObject, addItem } = this.props;
    let data = JSON.parse(JSON.stringify(dataObj));
    /*
     * author: szp
     * creat: 2019-08-15
     * tips: 修改如果下拉列表接口返回的是对象类型的，则转换成数组key类型的下拉
     */
    if (addItem) {
      data.unshift(addItem);
    }
    if (isObject) {
      const newData = [];
      for (const i in data) {
        if (data.hasOwnProperty(i)) {
          newData.push({ key: i, value: data[i] });
        }
      }
      data = newData;
    }

    const menu =
      data &&
      data.map((o, i) => (
        <Option key={o[selectItem.key]} value={o[selectItem.key]}>
          {Array.isArray(selectItem.valueKey)
            ? selectItem.valueKey.map((x, y) => o[x]).join('')
            : o[selectItem.valueKey]}
        </Option>
      ));
    return {
      menu,
    };
  }
  // 选中下拉框的回调
  onMenuItemClick(key, valueObj) {
    const { onChange, handleSelectChange } = this.props;
    const jud =
      this.props.selectItem &&
      Array.isArray(this.props.selectItem.valueKey) &&
      this.props.selectItem.valueKey.length > 1
        ? true
        : false;
    onChange &&
      onChange({
        value: valueObj.props.value,
        children: jud
          ? valueObj.props.children.replace(valueObj.props.value, '')
          : valueObj.props.children,
      });
    handleSelectChange &&
      handleSelectChange({
        value: valueObj.props.value,
        children: jud
          ? valueObj.props.children.replace(valueObj.props.value, '')
          : valueObj.props.children,
      });
  }
  // 聚焦的回调
  handleFocus = () => {
    const { dateApi, data } = this.props;
    if (data) {
      const menuObj = this.getMenu(data);
      this.setState({
        ...menuObj,
      });
    } else {
      dateApi && this.getAsyncDate(dateApi);
    }
  };
  render() {
    const { type, style, antd, placeholder, selectItem, showBoth } = this.props;
    const { menu, fetching } = this.state;
    if (!selectItem.data) {
      selectItem.data = {};
    }
    return (
      <Select
        showSearch
        {...antd}
        style={{ width: '100%', ...style }}
        showArrow={type ? false : true}
        dropdownMatchSelectWidth={false}
        placeholder={placeholder || '请选择'}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        value={
          showBoth
            ? `${selectItem.data.value}${selectItem.data.children}`
            : selectItem.data.children
        }
        optionFilterProp="children"
        getPopupContainer={triggerNode => triggerNode.parentNode}
        onSelect={(key, valueObj) => {
          this.onMenuItemClick(key, valueObj);
        }}
        onFocus={this.handleFocus}
        // onBlur={handleBlur}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }>
        {menu}
      </Select>
    );
  }
}
export default CsxFormSelect;
